<template>
  <div class="confirm-delete-dialog">
    <modal-title title="Delete" @close="$emit('cancel')"></modal-title>
    <p>{{ message }}</p>
    <button-bar>
      <button type="button" class="btn btn-danger" @click="yesClicked">
        Yes
      </button>
      <button type="button" class="btn btn-secondary" @click="noClicked">
        No
      </button>
    </button-bar>
  </div>
</template>
<script>
import ModalTitle from "@/components/common/modal/ModalTitle.vue";
import ButtonBar from "../buttons/ButtonBar.vue";

export default {
  components: { ButtonBar, ModalTitle },
  props: {
    message: {
      type: String,
      required: false,
      default: "Are you sure you want to delete this item?",
    },
  },
  methods: {
    yesClicked: function() {
      this.logDebug("User has confirmed delete operation.");
      this.$emit("confirm");
    },
    noClicked: function() {
      this.logDebug("User has cancelled delete operation.");
      this.$emit("cancel");
    },
  },
  emits: ["confirm", "cancel"],
};
</script>
